import {v4 as uuid} from 'uuid';
import {findIndex, includes, intersection} from 'lodash';
import {
    MODERATION_ZAJAVL_STATUS,
    NOT_SENT_ZAJAVL_STATUS,
    RETURN_REWORK_ZAJAVL_STATUS,
} from '@assets/js/constants/statusOnlineZajavl';
import {
    LVL_EDU_ADUNKT,
    LVL_EDU_ASPIRANT,
    LVL_EDU_ASSIST,
    LVL_EDU_INTER,
    LVL_EDU_SPO_KVALIF,
    LVL_EDU_SPO_SREDN_ZVENO,
} from '../constants/edu_lvls';

import {
    BUDGET,
    TARGETED_RECRUITMENT,
    SPECIAL_QUOTA,
    DOGOVOR,
    OTHER,
    SPECIAL_MILITARY_QUOTA,
} from '../constants/competition_budget_types';

export function getAllUrlParams(locationSearch) {
    const get = {};
    const param = locationSearch.split('?');
    param.forEach((val) => {
        if (val) {
            const valExplode = val.split('=');
            if (valExplode.length === 2) {
                get[valExplode[0]] = valExplode[1];
            }
        }
    });
    return get;
}

export function getDataListFromRefsList(refsList, schemes) {
    const dataList = [];
    refsList.forEach((refs) => {
        const docType = Number(refs.doc_type.value);
        if (docType) {
            const data = getSchemeRefsValues(schemes[docType].struct, refs);
            data.uuid = refs.uuid.value;
            data.id = Number(refs.doc_id.value);
            data.doc_type = docType;
            dataList.push(data);
        }
    });
    return dataList;
}

export function getSchemeRefsValues(schemeStruct, refs) {
    const data = {};
    Object.keys(schemeStruct).map((fieldName) => {
        switch (schemeStruct[fieldName].type.format) {
            case 'nested_multiple_entities':
                data[fieldName] = [];
                refs[fieldName].forEach((row) => {
                    data[fieldName].push(getSchemeRefsValues(schemeStruct[fieldName].type.element_fields, row));
                });
                data[fieldName] = JSON.stringify(data[fieldName]);
                break;
            case 'nested_one_of_entities':
                let typeSelected = refs[fieldName].type_selected.value;
                if (typeSelected === '0') {
                    typeSelected = 0;
                }
                const values = typeSelected
                    ? getSchemeRefsValues(
                        schemeStruct[fieldName].type.element_fields[typeSelected].type.element_fields,
                        refs[fieldName].values,
                    )
                    : {};
                data[fieldName] = {
                    type_selected: typeSelected,
                    values,
                };
                data[fieldName] = JSON.stringify(data[fieldName]);
                break;
            case 'nested_single_entity':
                const valuesCount = Object.keys(refs[fieldName]).length;
                if (valuesCount) {
                    data[fieldName] = getSchemeRefsValues(schemeStruct[fieldName].type.element_fields, refs[fieldName]);
                    // для объекта parent_identity в поле file_ids перед сохранением нужна обработка;
                    // т.к file_ids содержит функции, то они затираются stringify
                    if (fieldName === 'parent_identity') {
                        data[fieldName] = data[fieldName];
                    } else {
                        data[fieldName] = JSON.stringify(data[fieldName]);
                    }
                }
                break;
            case 'file':
                if (refs.hasOwnProperty(fieldName)) {
                    data[fieldName] = refs[fieldName];
                }
                break;
            case 'static_text':
                break;
            case 'radio':
            case 'date':
            case 'single_select':
            case 'tiny_text':
            case 'middle_text':
            default:
                data[fieldName] = refs[fieldName].value;
        }
    });
    return data;
}

export function getLabelType(row, types) {
    return row.doc_type
        ? types.find((element) => {
            return Number(element.id) === Number(row.doc_type);
        })
        : undefined;
}

export function prepareSetRows(rows) {
    return rows.length > 0
        ? rows.map((row) => {
            return {...row, uuid: uuid()};
        })
        : [{uuid: uuid()}];
}

export const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
}());

export const frendlyFormaterSizeInBytes = (bytes) => {
    const type = ['б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб'];
    let i = 0;
    while ((bytes / 1000 | 0) && i < type.length - 1) {
        bytes /= 1024;
        i++;
    }
    return `${bytes.toFixed(2)} ${type[i]}`;
};

export const getContestsLevelsEduUnique = (contests) => {
    const contestsLevelsEduUnique = [];
    contests.forEach((contest) => {
        if (contestsLevelsEduUnique.indexOf(contest.edu_level_id) === -1) {
            contestsLevelsEduUnique.push(contest.edu_level_id);
        }
    });
    return contestsLevelsEduUnique;
};

export const filterTemplatesDocumentsForZajavls = (templatesDocuments, zajavlStatus, contestsLevelsEduUnique) => {
    const filteredTemplatesDocuments = [];
    const templatesDocumentsKeys = Object.keys(templatesDocuments);
    for (let i = 0; i < templatesDocumentsKeys.length; i++) {
        if (templatesDocumentsKeys[i] === 'common'
            && [NOT_SENT_ZAJAVL_STATUS, MODERATION_ZAJAVL_STATUS, RETURN_REWORK_ZAJAVL_STATUS].indexOf(zajavlStatus) === -1
            && zajavlStatus !== undefined
        ) {
            continue;
        }
        if (['agreement', 'rejection'].includes(templatesDocumentsKeys[i])) {
            continue;
        }
        const filteredTemplatesDocumentsGroup = templatesDocuments[templatesDocumentsKeys[i]]
            .filter((document) => { return intersection(document.level_edu, contestsLevelsEduUnique).length >= 1; });
        if (filteredTemplatesDocumentsGroup.length > 0) {
            filteredTemplatesDocuments[templatesDocumentsKeys[i]] = filteredTemplatesDocumentsGroup;
        }
    }
    return filteredTemplatesDocuments;
};

export const filterTemplatesDocumentsForZajavlsConsentOrRefusal = (templatesDocuments, contestsLevelsEduUnique) => {
    const filteredTemplatesDocuments = [];
    const templatesDocumentsKeys = Object.keys(templatesDocuments);
    for (let i = 0; i < templatesDocumentsKeys.length; i++) {
        if (templatesDocumentsKeys[i] === 'common') {
            continue;
        }
        const filteredTemplatesDocumentsGroup = templatesDocuments[templatesDocumentsKeys[i]]
            .filter((document) => { return intersection(document.level_edu, contestsLevelsEduUnique).length >= 1; });
        if (filteredTemplatesDocumentsGroup.length > 0) {
            filteredTemplatesDocuments[templatesDocumentsKeys[i]] = filteredTemplatesDocumentsGroup;
        }
    }
    return filteredTemplatesDocuments;
};

export function getCommentFromCommentsZajavls(commentsZajavls, zajavlUuid) {
    const commentIndex = findIndex(commentsZajavls, {zajavl_uuid: zajavlUuid});
    return commentIndex !== -1 ? commentsZajavls[commentIndex].value : '';
}

export function removeCommentFromCommentsZajavls(commentsZajavls, zajavlUuid) {
    return commentsZajavls.filter((comment) => { return comment.zajavl_uuid !== zajavlUuid; });
}

export function setUidContests(contests) {
    if (Array.isArray(contests)) {
        contests.forEach((contest) => {
            contest.uuid = uuid();
        });
        return contests;
    }
    return [];
}

export const isAnyZajavlCompetitionsNeedConsentOrDenial = (zajavl) => {
    const eduLvlsWhichNoNeedConsentOrDenial = [LVL_EDU_ASPIRANT, LVL_EDU_ADUNKT, LVL_EDU_ASSIST, LVL_EDU_INTER, LVL_EDU_SPO_SREDN_ZVENO, LVL_EDU_SPO_KVALIF];
    return zajavl.hasOwnProperty('request_competitions')
        ? zajavl.request_competitions.some((element) => { return !includes(eduLvlsWhichNoNeedConsentOrDenial, element.edu_level_id); })
        : false;
};
